<div id="toolBar">
    <img (click)="cleanDoc();" class="intLink clickable" src="../../../../assets/images/cleanDoc.png"
    title="Clean"/>

    <img (click)="printDoc();" class="intLink clickable" src="../../../../assets/images/printDoc.png"
                    title="Print"/>

    <img (click)="formatDoc('undo');" class="intLink clickable" src="../../../../assets/images/undo.png"
    title="Undo"/>

    <img (click)="formatDoc('redo');" class="intLink clickable" src="../../../../assets/images/redo.png"
    title="Redo"/>

    <img (click)="formatDoc('removeFormat')" class="intLink clickable"
    src="../../../../assets/images/undoFormat.png"
    title="Remove formatting"/>

    <img (click)="formatDoc('bold');" class="intLink clickable" src="../../../../assets/images/bold.png"
    title="Bold"/>

    <img (click)="formatDoc('italic');" class="intLink clickable" src="../../../../assets/images/italic.png"
    title="Italic"/>

    <img (click)="formatDoc('underline');" class="intLink clickable"
    src="../../../../assets/images/underline.png"
    title="Underline"/>

    <img (click)="formatDoc('justifyleft');" class="intLink clickable"
    src="../../../../assets/images/justifyLeft.png"
    title="Left align"/>

    <img (click)="formatDoc('justifycenter');" class="intLink clickable"
    src="../../../../assets/images/justifyCenter.png"
    title="Center align"/>

    <img (click)="formatDoc('justifyright');" class="intLink clickable"
    src="../../../../assets/images/justifyRight.png"
    title="Right align"/>

    <img (click)="formatDoc('insertorderedlist');" class="intLink clickable"
    src="../../../../assets/images/insertOrderedList.png"
    title="Numbered list"/>

    <img (click)="formatDoc('insertunorderedlist');" class="intLink clickable"
    src="../../../../assets/images/bulletList.png"
    title="Dotted list"/>

    <img (click)="formatDoc('outdent');" class="intLink clickable"
    src="../../../../assets/images/indentation.png"
    title="Add indentation"/>

    <img (click)="formatDoc('indent');" class="intLink clickable"
    src="../../../../assets/images/deleteindentation.png"
    title="Delete indentation"/>

    <img (click)="addLink()" class="intLink clickable" src="../../../../assets/images/link.png"
    title="Link"/>
</div>

<iframe id="irb-text-editor-text-elem" name="irb-text-editor-text-elem"
style="width: 565px; height: 160px; border: 1px solid #CECECE;"></iframe>